// export const domain = "http://127.0.0.1:8000/api";
// export const url = "http://127.0.0.1:8000";
// export const domain_event =  "http://127.0.0.1:8000/api"
// ============
// export const domain = "https://tcdc-service.kisrasprint.com/api";
// export const domain_web = "https://tcdc-service.kisrasprint.com";
// export const domain_event = "https://tcdc-service.kisrasprint.com/api";
// export const domain_event_web = "https://tcdc-event.kisrasprint.com";
// // export const domain_article = "https://tcdc-service.kisrasprint.com/api";
// export const domain_article = "https://www.tcdc.or.th/v1/api";
// // export const domain_article =  "http://127.0.0.1:8000/api";
// // export const url = "https://tcdc-service.kisrasprint.com";
// export const url = "https://www.tcdc.or.th/v1";

// ============

// export const domain = "https://tcdc-service.kisrasprint.com/api";
// export const domain_web = "https://tcdc-service.kisrasprint.com";
// // export const domain_event = "https://www.tcdc-event.kisrasprint.com/api";
// export const domain_event = "https://tcdc-service.kisrasprint.com/api";
// export const domain_article = "https://tcdc-service.kisrasprint.com/api";
// export const url = "https://tcdc-service.kisrasprint.com";
// export const url_article = "https://article.tcdc.or.th/";


// =========
// export const domain_event =  "https://event.tcdc.or.th/api";
// export const domain_event_web =  "https://event.tcdc.or.th";
// export const domain_article =  "https://article.tcdc.or.th/api";

// PRODUCTION
export const domain = "https://www.tcdc.or.th/v1/api";
export const domain_web = "https://www.tcdc.or.th/v1";
// export const domain_event = "https://www.tcdc-event.kisrasprint.com/api";
export const domain_event = "https://www.tcdc.or.th/v1/api";
export const domain_article = "https://www.tcdc.or.th/v1/api";
export const url = "https://www.tcdc.or.th/v1";
export const url_article = "https://article.tcdc.or.th/";


export const defaultTitle = 'TCDC All Program กิจกรรมและนิทรรศการ';
export const defaultDescription = 'TCDC จัดกิจกรรม เวิร์กชอป นิทรรศการ อีเวนต์ ส่งเสริมให้เกิดความคิดสร้างสรรค์ ช่วยค้นหาไอเดีย เปลี่ยนวิธีคิด เพื่อหาทางออกใหม่ให้กับธุรกิจ';
export const defaultKeyword = 'TCDC, จัดกิจกรรม, เวิร์กชอป, นิทรรศการ, อีเวนต์, บทความ, ebook';
export const defaultUrl = 'https://www.tcdc.or.th/';
export const defaultImage = 'https://www.tcdc.or.th/v1/image/CEA-Online-Academy_1900x792%20(1).jpg';


import Vue from 'vue'
export const eventBus = new Vue()

export function setMetaTags(d, w, title, description, image = defaultImage, keyword = defaultKeyword) {
    // title
    if(title.includes('</')){
        let tag = document.createElement("html")
        tag.innerHTML= title
        d.title = tag.innerText
    }else{
        d.title = title
    }

    let currentUrl = decodeURIComponent(w.location.href)

    // canonical
    if (d.querySelector("link[rel='canonical']")) {
        d.querySelector("link[rel='canonical']").setAttribute('href', currentUrl)
    } else {
        let canonical = d.createElement('link')
        canonical.rel = 'canonical'
        canonical.href = currentUrl
        d.getElementsByTagName('title')[0].after(canonical)
    }

    // description
    if (d.querySelector("meta[name='description']")) {
        d.querySelector("meta[name='description']").setAttribute('content', description)
    } else {
        let descriptionTag = d.createElement('meta')
        descriptionTag.name = 'description'
        descriptionTag.content = description
        d.getElementsByTagName('title')[0].after(descriptionTag)
    }

    // keyword
    if (d.querySelector("meta[name='keyword']")) {
        d.querySelector("meta[name='keyword']").setAttribute('content', keyword)
    } else {
        let keywordTag = d.createElement('meta')
        keywordTag.name = 'keyword'
        keywordTag.content = keyword
        d.getElementsByTagName('title')[0].after(keywordTag)
    }

    // og:image
    if (d.querySelector("meta[property='og:image']")) {
        d.querySelector("meta[property='og:image']").setAttribute('content', image)
    } else {
        let ogimage = d.createElement('meta')
        ogimage.property = 'og:image'
        ogimage.content = image
        d.getElementsByTagName('title')[0].after(ogimage)
    }

    // og:title
    if (d.querySelector("meta[property='og:title']")) {
        d.querySelector("meta[property='og:title']").setAttribute('content', title)
    } else {
        let ogtitle = d.createElement('meta')
        ogtitle.property = 'og:title'
        ogtitle.content = title
        d.getElementsByTagName('title')[0].after(ogtitle)
    }

    // og:description
    if (d.querySelector("meta[property='og:description']")) {
        d.querySelector("meta[property='og:description']").setAttribute('content', description)
    } else {
        let ogdesc = d.createElement('meta')
        ogdesc.property = 'og:description'
        ogdesc.content = description
        d.getElementsByTagName('title')[0].after(ogdesc)
    }

    // og:url
    if (d.querySelector("meta[property='og:url']")) {
        d.querySelector("meta[property='og:url']").setAttribute('content', currentUrl)
    } else {
        let ogurl = d.createElement('meta')
        ogurl.property = 'og:url'
        ogurl.content = currentUrl
        d.getElementsByTagName('title')[0].after(ogurl)
    }
}


export function setDefaultMetaTag(d) {
    // title
    d.title = defaultTitle

    let currentUrl = decodeURIComponent(defaultUrl)

    // canonical
    if (d.querySelector("link[rel='canonical']")) {
        d.querySelector("link[rel='canonical']").setAttribute('href', currentUrl)
    } else {
        let canonical = d.createElement('link')
        canonical.rel = 'canonical'
        canonical.href = currentUrl
        d.getElementsByTagName('title')[0].after(canonical)
    }

    // description
    if (d.querySelector("meta[name='description']")) {
        d.querySelector("meta[name='description']").setAttribute('content', defaultDescription)
    } else {
        let descriptionTag = d.createElement('meta')
        descriptionTag.name = 'description'
        descriptionTag.content = defaultDescription
        d.getElementsByTagName('title')[0].after(descriptionTag)
    }

    // keyword
    if (d.querySelector("meta[name='keyword']")) {
        d.querySelector("meta[name='keyword']").setAttribute('content', defaultKeyword)
    } else {
        let keywordTag = d.createElement('meta')
        keywordTag.name = 'keyword'
        keywordTag.content = defaultKeyword
        d.getElementsByTagName('title')[0].after(keywordTag)
    }

    // og:image
    if (d.querySelector("meta[property='og:image']")) {
        d.querySelector("meta[property='og:image']").setAttribute('content', defaultImage)
    } else {
        let ogimage = d.createElement('meta')
        ogimage.property = 'og:image'
        ogimage.content = defaultImage
        d.getElementsByTagName('title')[0].after(ogimage)
    }

    // og:title
    if (d.querySelector("meta[property='og:title']")) {
        d.querySelector("meta[property='og:title']").setAttribute('content', defaultTitle)
    } else {
        let ogtitle = d.createElement('meta')
        ogtitle.property = 'og:title'
        ogtitle.content = defaultTitle
        d.getElementsByTagName('title')[0].after(ogtitle)
    }

    // og:description
    if (d.querySelector("meta[property='og:description']")) {
        d.querySelector("meta[property='og:description']").setAttribute('content', defaultDescription)
    } else {
        let ogdesc = d.createElement('meta')
        ogdesc.property = 'og:description'
        ogdesc.content = defaultDescription
        d.getElementsByTagName('title')[0].after(ogdesc)
    }

    // og:url
    if (d.querySelector("meta[property='og:url']")) {
        d.querySelector("meta[property='og:url']").setAttribute('content', currentUrl)
    } else {
        let ogurl = d.createElement('meta')
        ogurl.property = 'og:url'
        ogurl.content = currentUrl
        d.getElementsByTagName('title')[0].after(ogurl)
    }

}
